import React            from 'react';
import LangMenu         from './LangMenu';
import SignOutButton    from '../SignOutButton';
import Logos            from './Logos';
import colors           from '../../utils/colors';
import MenuRoundedIcon  from '@material-ui/icons/MenuRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { makeStyles }   from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root : {
        position:       'fixed',
        top:            0,
        left:           0,
        height:         100,
        transition:     'all 1s'
    },
    topBar: {
       /*  position:        'fixed',
        top:             0,
        left:            0, */
        height:          100,
        width:           '100vw',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'space-between',
        backgroundColor: '#EEF',
    },
    nav: {
      flex:            1,
      width:           55,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
    },
    icon_container: {
      width:           45,
      height:          45,
      borderRadius:    '50%',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      cursor:          'pointer',
      border:          `1px solid ${ colors.primary }`
    },
    icon: {
      color:    colors.primary,
      fontSize: 28
    }
}))

type TopbarProps = {
  size:               number[];
  navbarSize:         number;
  lang:               string;
  page:               string;
  wideScreen:         boolean;
  showSmallNavBar:    boolean;
  setLang:            (val: string) => void;
  setPage:            (val: string) => void;
  setPageOpacity:     (val: number) => void;
  setShowSmallNavBar: (val: boolean) => void;
  logOut:             () => void;
}

const Topbar: React.FC<TopbarProps> = ({ 
  size,
  navbarSize,
  lang,
  page,
  wideScreen,
  showSmallNavBar,
  setLang,
  setPage, 
  setPageOpacity,
  setShowSmallNavBar,
  logOut
}) => {

  const classes = useStyles();

  const [initialPos, setInitialPos] = React.useState(false)

  React.useEffect(() => {
    setTimeout(() => { setInitialPos(true) },10)
  },[])

  return (
    <div 
       className = { classes.root }
       style     = {{
          top: initialPos ? 0 : -100,
       }}
    >
        <div className = { classes.topBar }>
            {
              !wideScreen
              &&
              <div className = { classes.nav }>
                <div 
                   className = { classes.icon_container }
                   onClick   = { () => { setShowSmallNavBar(!showSmallNavBar) }}
                >
                  {
                    showSmallNavBar ? <CloseRoundedIcon className = { classes.icon }/> : <MenuRoundedIcon className = { classes.icon }/>
                  }
                </div>
              </div>
            }
            {
              wideScreen
              &&
              <SignOutButton
                 lang   = { lang }
                 logOut = { logOut }
              />
            }
            {
              wideScreen
              &&
              <LangMenu
                size       = { size } 
                wideScreen = { wideScreen }
                lang       = { lang }
                setLang    = { setLang }
              />
            }
            <Logos 
              size = { size } 
              wideScreen = { wideScreen }
            />
        </div>

    </div>
  );
}




export default Topbar;






/**
 * 
 * 
 *  {
              !wideScreen
              &&
              <div className = { classes.nav }>
                {
                    pages.map((val) => {
                      return(
                        <PageSelector
                          key         = { `${ val }_` }
                          val         = { val }
                          page        = { page }
                          handleClick = { handleClick }
                        />
                      )
                    })
                }
              </div>
            }



 */